import { useCrudActions } from '@/common/view/useCrudActions';
import { googleService } from '@/services/google';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';

export default function () {
    const crudAction = useCrudActions();

    const model = reactive({
        isNew: true,
        packageName: '',
        clientId: '',
        clientSecret: '',
        accessToken: '',
        refreshToken: '',
        prefixSchema: ''
    });

    const validations = {
        packageName: { required },
        clientId: { required },
        clientSecret: { required },
        accessToken: { required },
        refreshToken: { required },
        prefixSchema: { required }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: googleService.payment.get,
        onSuccess: ({ data }) => {
            model.isNew = false;
            model.packageName = data.packageName;
            model.clientId = data.clientId;
            model.clientSecret = data.clientSecret;
            model.accessToken = data.accessToken;
            model.refreshToken = data.refreshToken;
            model.prefixSchema = data.prefixSchema;
        },
        onError: () => {
            model.isNew = true;
            model.packageName = '';
            model.clientId = '';
            model.clientSecret = '';
            model.accessToken = '';
            model.refreshToken = '';
            model.prefixSchema = '';
        }
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                googleService.payment.update(
                    model.packageName,
                    model.clientId,
                    model.clientSecret,
                    model.accessToken,
                    model.refreshToken,
                    model.prefixSchema
                ),
            onSuccess: fetch
        }),
        remove: crudAction.confirmAndRemove({
            request: googleService.payment.remove,
            onSuccess: fetch
        })
    };

    return { model, v$, fetch, actions };
}
